module.exports = __webpack_public_path__ + "static/media/05_hero_desktop.7fd449bd.jpg";